import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Location } from '@angular/common';

import * as _ from 'lodash';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ParticipantsPluginService } from './participants-plugin.service';

@Component({
    templateUrl: './participants-add.component.html',
    standalone: false
})
export class ParticipantsAddPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  participantsForm: UntypedFormGroup;
  public processing = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ParticipantsPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) {
        this.goToBack();
      }

      this.pluginId = pluginId;

      this.initData();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.participantsForm = this.fb.group({
      participants: this.fb.array([this.initParticipant()])
    });
    this.cdRef.detectChanges();
  }

  initParticipant() {
    return this.fb.group({
      name: ['', Validators.required],
      function: ['', Validators.required],
      personType: [200]
    });
  }

  get formData() {
    return <UntypedFormArray>this.participantsForm.controls['participants'];
  }

  add() {
    const control = <UntypedFormArray>this.participantsForm.controls['participants'];
    control.push(this.initParticipant());
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.participantsForm.controls['participants'];
    control.removeAt(i);
  }

  save(model: any) {
    // this.processing = true;
    // this.service.addParticipants(model.participants).subscribe(participants => {
    //     this.processing = false;
    //     this.goToBack();
    // });
  }
}
